import ZipCodeMap from './components/ZipCodeMap'
import MapModal from './components/MapModal';
import { getIPData } from './helpers/IPDataHelper';
import IPInfo from './models/IPInfo';
import getFlagEmojiUrl from './util/getFlagEmojiUrl';

export default {
  'fof/geoip/components/ZipCodeMap': ZipCodeMap,
  'fof/geoip/components/MapModal': MapModal,
  'fof/geoip/helpers/getIPData': getIPData,
  'fof/geoip/models/IPInfo': IPInfo,
  'fof/geoip/utils/getFlagEmojiUrl': getFlagEmojiUrl,
};
